import { createRouter, createWebHistory } from 'vue-router'
import ProfileView from '../views/ProfileView.vue'
import SinglePageView from '../views/SinglePageView.vue'
import SectionView from '../views/SectionView.vue'
import TestView from '../views/TestView.vue'
import ContactView from '../views/ContactView.vue'
import ProfileSettings from '../components/ProfileSettings.vue'
import ProfileCertificate from '../components/ProfileCertificate.vue'
import ProfileChangePassword from '../components/ProfileChangePassword.vue'
import SigninView from '../views/SigninView.vue'
import SignupView from '../views/SignupView.vue'
import ForgotPassword from '../views/ForgotPasswordView.vue'
import ResetPassword from '../views/ResetPasswordView.vue'
import SignoutView from '../views/SignoutView.vue'
import HeaderView from '../views/HeaderView.vue'
import PageNotFoundView from '../views/PageNotFoundView.vue'
import store from '@/store/index'
import axios from "@/http";

const DEFAULT_TITLE = 'ძირითადი საკითხები თანასწორობის უფლების შესახებ';
const publicPages = ['signin', 'signup', 'forgotPassword', 'resetPassword', 'signout'];

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: () => {
      return { name: 'section', params: { id: store.getters.step } }
    }
  },
  {
    path: '/about-course',
    name: 'aboutCourse',
    meta: {
      title: 'კურსის შესახებ'
    },
    components: {
      default: SinglePageView,
      HeaderView
    }
  },
  {
    path: '/glossary',
    name: 'glossary',
    meta: {
      title: 'ტერმინთა განმარტება'
    },
    components: {
      default: SinglePageView,
      HeaderView
    }
  },
  {
    path: '/purpose',
    name: 'purpose',
    meta: {
      title: 'კურსის აქტუალურობა'
    },
    components: {
      default: SinglePageView,
      HeaderView
    }
  },
  {
    path: '/references',
    name: 'references',
    meta: {
      title: 'გამოყენებული რესურსები'
    },
    components: {
      default: SinglePageView,
      HeaderView
    }
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: 'კონტაქტი'
    },
    components: {
      default: ContactView,
      HeaderView
    }
  },
  {
    path: '/section/:id',
    name: 'section',
    components: {
      default: SectionView,
      HeaderView
    },
    props: true
  },
  {
    path: '/test/:id',
    name: 'test',
    components: {
      default: TestView,
      HeaderView
    },
    props: true
  },
  {
    path: '/profile',
    name: 'profile',
    components: {
      default: ProfileView,
      HeaderView
    },
    meta: {
      name: 'profile'
    },
    redirect: '/profile/settings',
    children: [{
      path: 'settings',
      name: 'profile.settings',
      components: {
        ProfileSettings
      }
    },
    {
      path: 'change-password',
      name: 'profile.changepassword',
      component: ProfileChangePassword
    },
    {
      path: 'certificate',
      name: 'profile.certificate',
      component: ProfileCertificate
    }]
  },
  {
    path: '/signin',
    name: 'signin',
    component: SigninView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password/:token/',
    name: 'resetPassword',
    component: ResetPassword,
    props: true
  },
  {
    path: '/signout',
    name: 'signout',
    component: SignoutView
  },
  { path: '/:pathMatch(.*)*', component: PageNotFoundView }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.name === 'profile' && to.meta.name === "profile")
      return false

    document.getElementById('app').scrollIntoView({ behavior: 'instant' });
  }
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' - ' + DEFAULT_TITLE : DEFAULT_TITLE;

  if (!publicPages.includes(to.name)) {
    const token = store.state.token
    const user = store.state.user

    if (!token) {
      next({ name: 'signin' })
    } else {

      const checkToken = await axios.post('/checkToken', {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      })

      if (checkToken.data.success) {
        if (!user) {
          const currentUser = await axios.post('/getCurrentUser', {}, {
            headers: { 'Authorization': `Bearer ${token}` }
          })

          if (currentUser.data.success) {
            store.commit('setUser', currentUser.data.user)
            next()
          } else {
            next({ name: 'signin' })
          }
        } else {
          next()
        }
      } else {
        next({ name: 'signin' })
      }
    }
  } else {
    next()
  }
});


export default router
